import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of, Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { catchError } from 'rxjs/operators';
import { MasterService } from '../../../@core/services/master.service';
import { NbToastrService } from '@nebular/theme';
import { ExportService } from '../../../@core/services/export.service';
import { takeUntil } from 'rxjs/operators';
import { log } from 'console';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'ngx-overview-manager',
  templateUrl: './overview-manager.component.html',
  styleUrls: ['./overview-manager.component.scss'],
})
export class OverviewManagerComponent implements OnInit{
 form: FormGroup;
  projectForm: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;  
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any ='';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  selectedRfqDate: any = "";
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  allCustomerData = [];
  overdueCount : number ;
  // allCustomerData = [
  //   {
  //     serialNumber: 100001,
  //     customerName: "John Doe",
  //     city: "New York",
  //     state: "NY",
  //     country: "USA",
  //     gstNumber: "GST12345",
  //     createdBy: "Admin",
  //     createdOn: "2024-10-01",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-11-01",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100002,
  //     customerName: "Jane Smith",
  //     city: "Los Angeles",
  //     state: "CA",
  //     country: "USA",
  //     gstNumber: "GST67890",
  //     createdBy: "Manager",
  //     createdOn: "2024-09-15",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-10-20",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100003,
  //     customerName: "Michael Johnson",
  //     city: "Chicago",
  //     state: "IL",
  //     country: "USA",
  //     gstNumber: "GST24680",
  //     createdBy: "Staff",
  //     createdOn: "2024-08-10",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-09-05",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100004,
  //     customerName: "Emily Davis",
  //     city: "Houston",
  //     state: "TX",
  //     country: "USA",
  //     gstNumber: "GST13579",
  //     createdBy: "Admin",
  //     createdOn: "2024-07-20",
  //     lastModifiedBy: "Manager",
  //     lastModifiedOn: "2024-09-25",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100005,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100006,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: false,
  //   },
  // ];
  engineersData = [];
  // allCustomerData = [
  //   {
  //     serialNumber: 1,
  //     projectName: "Project Alpha",
  //     customerName: "Customer A",
  //     rfqDate: new Date("2024-01-15"),
  //     assignedTo: "John Doe",
  //     assignedDate: new Date("2024-01-20"),
  //     expetedCompletionDate: new Date("2024-02-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "50",
  //     status: "In Progress",
  //     currentStage: "procurement",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 2,
  //     projectName: "Project Beta",
  //     customerName: "Customer B",
  //     rfqDate: new Date("2024-02-01"),
  //     assignedTo: "Jane Smith",
  //     assignedDate: new Date("2024-02-05"),
  //     expetedCompletionDate: new Date("2024-03-01"),
  //     targetLeadTime: "3 weeks",
  //     ageing: "1 week",
  //     progress: "30",
  //     status: "In Progress",
  //     currentStage: "Costing",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 3,
  //     projectName: "Project Gamma",
  //     customerName: "Customer C",
  //     rfqDate: new Date("2024-01-10"),
  //     assignedTo: "Alice Johnson",
  //     assignedDate: new Date("2024-01-12"),
  //     expetedCompletionDate: new Date("2024-02-10"),
  //     targetLeadTime: "6 weeks",
  //     ageing: "4 weeks",
  //     progress: "70",
  //     status: "On Hold",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 4,
  //     projectName: "Project Delta",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-01-25"),
  //     assignedTo: "Bob Williams",
  //     assignedDate: new Date("2024-01-30"),
  //     expetedCompletionDate: new Date("2024-03-05"),
  //     targetLeadTime: "5 weeks",
  //     ageing: "3 weeks",
  //     progress: "20",
  //     status: "Delayed",
  //     currentStage: "procurement",
  //     activeStatus: false
  //   },
  //   {
  //     serialNumber: 5,
  //     projectName: "Project Epsilon",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "90",
  //     status: "Not Started",
  //     currentStage: "Costing",
  //     activeStatus: true
  //   },
  //   {
  //     serialNumber: 6,
  //     projectName: "Project E",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "20%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 7,
  //     projectName: "Project M",
  //     customerName: "Customer M",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-04-15"),
  //     expetedCompletionDate: new Date("2024-06-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "30%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   },
  //   {
  //     serialNumber: 8,
  //     projectName: "Project M",
  //     customerName: "Customer OR",
  //     rfqDate: new Date("2024-08-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-12-15"),
  //     targetLeadTime: "12 weeks",
  //     ageing: "1 weeks",
  //     progress: "40%",
  //     status: "Open",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version: 'Version 2'
  //   }
  // ];
  
  
  // pageSize: number;
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string;
  isSaving: any;
  customerForm: any;
  allCustomerDetails = [];
  userId: number;
  selectedCustomerId: any;
  currentDate: string;
  assignDate: string;
  projectsData: any;
  editingRowId: number | null = null;
  openStatusCount: number;
  changedstage: any;
    fromExpectedCompletionDate: string = '';
toExpectedCompletionDate: string = '';

fromRfqDate: string = '';
toRfqDate: string = '';
 showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false;

  constructor(private f_builder: FormBuilder,
              private router: Router,
              private modalService: NgbModal,
               private masterService: MasterService,
               private datePipe: DatePipe,
               private notify: NbToastrService
              ) { 
                const now = new Date();
                // this.currentDate = now.toISOString(); 
                this.currentDate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd');
                this.assignDate =  this.datePipe.transform(new Date(), 'yyyy-MM-dd');
              }


  ngOnInit(): void {
    this.userId = Number(sessionStorage.getItem('user_id'));
    this.projectForm = this.f_builder.group({
      newProjectName: ['', Validators.required],
      customerFullName: ['', Validators.required],
      rfqDate: ['', Validators.required],
      completionDate: ['', Validators.required],
      targetLT: ['', Validators.required]
    });

    this.customerForm = this.f_builder.group({
      _customerFullName: ['', [Validators.required, Validators.minLength(2)]],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      // gstNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{15}$/)]], // Example GST validation
      gstNumber: ['', [Validators.required]], // Example GST validation
    });
    
    this.getAllcustomers(); 
    this.getdata(); 
    this.getAllProjectData(); 
  }
  getdata() {
    debugger
    let manager_id = {
      'manager_id': Number(this.userId),
    }
    this.masterService.get_manager_and_engineers(manager_id).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result;
        this.engineersData = data.engineers;
        console.log('engineersData', this.engineersData);
        debugger;
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }
  getAllcustomers() {
    debugger
    let cus = {
      "operation_type": "READALL"
      }
    this.masterService.all_customers(cus).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        this.allCustomerDetails = result;
        console.log('allCustomerDetails', this.allCustomerDetails);
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }
    })
  }
  // onSelectCustomer() {
  //   this.matchedCustomerData = this.allCustomerData
  //     .filter(cus => cus.customerName === this.selectedCustomerName)
  //     .map(cus => ({
  //       customerName: cus.customerName,
  //       serialNumber: cus.serialNumber,
  //       city: cus.city,
  //       state: cus.state,
  //       country: cus.country,
  //       gstNumber: cus.gstNumber,
  //       createdBy: cus.createdBy,
  //       createdOn: cus.createdOn,
  //       lastModifiedBy: cus.lastModifiedBy,
  //       lastModifiedOn: cus.lastModifiedOn,
  //       activeStatus: cus.activeStatus,
  //     }));
  // }

  // onSelectCustomer() {
  //   this.matchedCustomerData = this.allCustomerData
  //     .filter(cus => cus.customerName === this.selectedCustomerName)
  //     .map(cus => ({
  //       serialNumber: cus.serialNumber,
  //       projectName: cus.projectName,
  //       customerName: cus.customerName,
  //       rfqDate: cus.rfqDate,
  //       assignedTo: cus.assignedTo,
  //       assignedDate: cus.assignedDate,
  //       expetedCompletionDate: cus.expetedCompletionDate,
  //       targetLeadTime: cus.targetLeadTime,
  //       ageing: cus.ageing,
  //       progress: cus.progress,
  //       status: cus.status,
  //       currentStage: cus.currentStage,
  //       activeStatus: cus.activeStatus,
  //     }));
  // }

  onSearch(value: any){
    debugger
    this.searchText = value.target.value;
    // this.searchText = this.selectedCustomerName;
    const isCustomerExists = this.allCustomerData.some(
      (customer) => customer.customer_name.toLowerCase() === this.searchText.toLowerCase()
    );
    this.showAddCustomerButton = this.searchText.trim() !== '' && !isCustomerExists;
  }

  onSelectCustomer() {
    debugger;
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    console.log('Selected Customer:', this.selectedCustomerName);
    this.matchedCustomerData = this.allCustomerData
      .filter(cus => cus.customer_name === this.selectedCustomerName)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
      console.log('matched CustomerData', this.matchedCustomerData)
  }

  addNewCustomer() {
    debugger
    if (this.searchText) {
      let customerModal = "customerModal"
      this.openCustomerModel(customerModal);
      
      // const newCustomer = {
      //   serialNumber: this.allCustomerData.length + 1,
      //   projectName: 'Default Project',
      //   customerName: this.searchText,
      //   rfqDate: new Date(),
      //   assignedTo: 'Unassigned',
      //   assignedDate: new Date(),
      //   expetedCompletionDate: new Date(),
      //   targetLeadTime: 'N/A',
      //   ageing: 'N/A',
      //   progress: '0%',
      //   status: 'New',
      //   currentStage: 'Costing',
      //   activeStatus: true,
      // };
      // this.allCustomerData.push(newCustomer);
      // this.selectedCustomerName = this.searchText;
      // this.showAddCustomerButton = false;
      // console.log(`New customer "${this.searchText}" added.`);
    }
  }
  onSelectEnginner() {
    debugger
    this.selectedCustomerName = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.matchedCustomerData = this.allCustomerData
      .filter(cus => Number(cus.assigned_to_id) === Number(this.selectedEngineer))
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
  }
  onSelectStage(eve: any) {
    debugger;
    // console.log('eve', eve);
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    let selectedStage = eve.target.value
    console.log('val', selectedStage);
    debugger
    this.matchedCustomerData = this.allCustomerData
      .filter(cus => cus.currentstage === this.selectedCurrentStage)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
  }
  // onSelectMonthCompletion() {
  //   this.matchedCustomerData = this.allCustomerData
  //     .filter(cus => cus.expetedCompletionDate === this.selectedExpetedCompletionDate)
  //     .map(cus => ({
  //       serialNumber: cus.serialNumber,
  //       projectName: cus.projectName,
  //       customerName: cus.customerName,
  //       rfqDate: cus.rfqDate,
  //       assignedTo: cus.assignedTo,
  //       assignedDate: cus.assignedDate,
  //       expetedCompletionDate: cus.expetedCompletionDate,
  //       targetLeadTime: cus.targetLeadTime,
  //       ageing: cus.ageing,
  //       progress: cus.progress,
  //       status: cus.status,
  //       currentStage: cus.currentStage,
  //       activeStatus: cus.activeStatus,
  //     }));
  // }
  onSelectCompletionDate() {
    
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';    
    this.selectedRfqDate = '';
    console.log('Selected Expected Completion Date:', this.selectedExpetedCompletionDate);
    // Add any additional logic here when the date changes
    this.matchedCustomerData = this.allCustomerData
    .filter(cus => cus.expectedCompletionDate === this.selectedExpetedCompletionDate)
    .map(cus => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    this.applyDateFilters();
  }

  onDateRangeChange() {
   
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    console.log('Selected RFQ Date:', this.selectedRfqDate);
    // Add any logic you need when the date changes
    this.matchedCustomerData = this.allCustomerData
    .filter(cus => cus.rfqDate === this.selectedRfqDate)
    .map(cus => ({
      serialNumber: cus.serialNumber,
      rfqDate: cus.rfqDate,
      expectedCompletionDate: cus.expectedCompletionDate,
      project_id: cus.project_id,
      projectName: cus.projectName,
      targetLeadTime: cus.targetLeadTime,
      created_by_id: cus.created_by_id,
      created_date: cus.created_date,
      assigned_to_id: cus.assigned_to_id,
      assigned_date: cus.assigned_date,
      customer_id: cus.customer_id,
      ageing: cus.ageing,
      progress: cus.progress,
      status: cus.status,
      currentstage: cus.currentstage,
      activestatus: cus.activestatus,
      customer_name: cus.customer_name
    }));
    this.applyDateFilters();
  }
  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerData
      .filter(cus => cus.customerName === this.selectedCustomerName)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
  }
  applyDateFilters() {
  this.selectedCustomerName = '';
  this.selectedEngineer = '';
  this.selectedCurrentStage = '';
  this.selectedExpetedCompletionDate = '';
  this.selectedRfqDate = '';

  this.matchedCustomerData = this.allCustomerData.filter(cus => {
    const ecdDate = cus.expectedCompletionDate ? new Date(cus.expectedCompletionDate) : null;
    const rfqDate = cus.rfqDate ? new Date(cus.rfqDate) : null;

    const fromECD = this.fromExpectedCompletionDate ? new Date(this.fromExpectedCompletionDate) : null;
    const toECD = this.toExpectedCompletionDate ? new Date(this.toExpectedCompletionDate) : null;

    const fromRFQ = this.fromRfqDate ? new Date(this.fromRfqDate) : null;
    const toRFQ = this.toRfqDate ? new Date(this.toRfqDate) : null;

    const ecdMatch =
      (!fromECD || (ecdDate && ecdDate >= fromECD)) &&
      (!toECD || (ecdDate && ecdDate <= toECD));

    const rfqMatch =
      (!fromRFQ || (rfqDate && rfqDate >= fromRFQ)) &&
      (!toRFQ || (rfqDate && rfqDate <= toRFQ));

    return ecdMatch && rfqMatch;
  }).map(cus => ({
    serialNumber: cus.serialNumber,
    rfqDate: cus.rfqDate,
    expectedCompletionDate: cus.expectedCompletionDate,
    projectName: cus.projectName,
    targetLeadTime: cus.targetLeadTime,
    created_by_id: cus.created_by_id,
    created_date: cus.created_date,
    assigned_to_id: cus.assigned_to_id,
    assigned_date: cus.assigned_date,
    assigned_to_name: cus.assigned_to_name,
    customer_id: cus.customer_id,
    ageing: cus.ageing,
    progress: cus.progress,
    status: cus.status,
    currentstage: cus.currentstage,
    activestatus: cus.activestatus,
    customer_name: cus.customer_name,
    // version_id: cus.version_id || this.versions[this.versions.length - 1]
  }));
}

  resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
  }
  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
  }
   // Open ECD Modal
  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
  }
  
  activeTab: number = 1; // Track the active tab

  // Sample data for each table
  tableData1 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' },
    { column1: 'Row 2, Col 1', column2: 'Row 2, Col 2', column3: 'Row 2, Col 3' }
  ];
  tableData2 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData3 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData4 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    this.activeTab = tabNumber;
  }

  back(){
    this.router.navigate(['/master/additional-charges/table']);
  }

  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal) {
    debugger
    this.modalRef = this.modalService.open(customerModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }),this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  resetFields() {
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    this.editProjectRow(null);
    this.getAllProjectData();
  }
  openProjectModel(projectModal) {
    this.showAddCustomerButton = false;
    this.modalRef = this.modalService.open(projectModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }),this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  onLandinCost(landinCostModal) {
    this.modalRef = this.modalService.open(landinCostModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }),this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // closeModal() {
  //   debugger
  //   this.modalService.dismissAll();
  // }
  closeModal() {
    debugger
    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }

  // save() {
  //   debugger
  //   if (this.form.invalid) {


  //   } else {
  //     this.modalService.dismissAll();
  //   }
  // }
  onAddNewCustomer(event?: any): void {
    debugger;
    // this.selectedCustomerName = event?.customerName;
    this.selectedCustomerId = event?.id;
    console.log('selectedCustomerId', this.selectedCustomerId);
  }
  
  save(): void {
    debugger;
    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }
  
    // Set a flag to indicate that the save process is in progress
    this.isSaving = true;
  
    if (this.projectForm.valid) {
      // const payload = {
      //   projectName: this.projectForm.get('newProjectName')?.value,
      //   customerName: this.projectForm.get('customerFullName')?.value,
      //   rfqDate: this.projectForm.get('rfqDate')?.value,
      //   expectedCompletionDate: this.projectForm.get('completionDate')?.value,
      //   targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
      //   landingCost: [0] // Assuming landingCost is always [0] for now
      // };
      const payload = {
        action: "INSERT", 
        project_id: 0,
        // project_id: 1,
        projectName: this.projectForm.get('newProjectName')?.value,
        rfqDate: this.projectForm.get('rfqDate')?.value,
        expectedCompletionDate: this.projectForm.get('completionDate')?.value,
        targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
        created_by_id: this.userId, 
        created_date: this.currentDate, 
        // assigned_to_id: null, 
        assigned_to_id: 2, 
        assigned_date: this.assignDate, 
        customer_id: Number(this.selectedCustomerId), 
        // ageing: null,
        ageing: 0,
        progress: "0%", 
        status: "Open", 
        currentstage: "", 
        activestatus: "" 
      };
  
      console.log('payload', payload);
  
      // API call to save data
      // this.masterService.add_project(payload).pipe(
      this.masterService.manage_projects(payload).pipe(
        catchError((error) => {
          console.error('Error saving data:', error);
          // Handle error by showing a user-friendly message
          // alert('An error occurred while saving the project data. Please try again.');
          this.notify.danger('An error occurred while saving the project data. Please try again.');
          return of(null); // Return a fallback observable
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            console.log('Project saved successfully:', response);
            // alert('Project saved successfully.');
            this.notify.success('Project saved successfully.');
            // Reset the projectForm after success
            this.projectForm.reset();
            this.closeModal();
            this.getAllProjectData();
          }
        },
        error: (error) => {
          console.error('Unexpected error:', error);
        },
        complete: () => {
          // Reset the saving flag after the process is complete
          this.isSaving = false;
        }
      });
    } else {
      // alert('Please fill in all required fields.');
      this.notify.info('Please fill in all required fields.');
      console.log('Form is invalid');
      // Optionally reset the form if invalid
      this.projectForm.reset();
  
      // Reset the saving flag
      this.isSaving = false;
    }
  }

  getAllProjectData() {
   let payloadData = {
      "action": "SELECT_BY_CREATED_USERID",
        "created_by_id": this.userId
    }
    this.masterService.manage_projects(payloadData).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result['data'];
        // this.sortDataDescending(data);
        // this.projectsData = result['data'];
             data.sort((a: any, b: any) => {
      return new Date(b.assigned_date).getTime() - new Date(a.assigned_date).getTime();
    });
        this.allCustomerData = data;
        this.matchedCustomerData = data;
        console.log('allCustomerData', this.allCustomerData);
        // Count the number of rows with status === 'Open'
        const openStatusCount = this.matchedCustomerData.filter(customer => customer.status === 'Open' || customer.status === 'In Progress').length;
        // Store it in a variable
        this.openStatusCount = openStatusCount;

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
        console.log('Today:', today);
        
        let overdueCount = this.matchedCustomerData.filter(item => {
          const expectedDate = new Date(item.expectedCompletionDate);
          expectedDate.setHours(0, 0, 0, 0); // Reset expected date to midnight
          return expectedDate < today; // Compare dates
        }).length;

      this.overdueCount = overdueCount;

      console.log('Number of overdue count :', this.overdueCount);


        console.log('Number of rows with status "Open":', this.openStatusCount);
        debugger;
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }

  // sortDataDescending(data) {
  //   data.sort((a, b) => {
  //     return new Date(b.created_date).getTime() - new Date(a.created_date).getTime();
  //   });
  // }

  saveCustomer() {
    debugger
    if (this.customerForm.invalid) {

    } else {
      // Prevent duplicate API calls
      if (this.isSaving) {
        return;
      }

      // Set a flag to indicate that the save process is in progress
      this.isSaving = true;

      if (this.customerForm.valid) {
        const payload = {
          operation_type: "CREATE",
          customerName: this.customerForm.get('_customerFullName')?.value,
          city: (this.customerForm.get('city')?.value).trim(),
          state: (this.customerForm.get('state')?.value).trim(),
          country: (this.customerForm.get('country')?.value).trim(),
          gstNumber: (this.customerForm.get('gstNumber')?.value).trim(),
        };

        console.log('payload', payload);

        // API call to save data
        this.masterService.create_customers(payload).pipe(
          catchError((error) => {
            console.error('Error saving data:', error);
            // Handle error by showing a user-friendly message
            // alert('An error occurred while saving the project data. Please try again.');
            this.notify.danger('An error occurred while saving the project data. Please try again.');
            return of(null); // Return a fallback observable
          })
        ).subscribe({
          next: (response) => {
            if (response) {
              console.log('Customer saved successfully:', response);
              // alert('Customer saved successfully.');
              this.notify.success('Customer saved successfully.');
              // Reset the customerForm after success
              this.customerForm.reset();
              this.closeModal();
            }
          },
          error: (error) => {
            console.error('Unexpected error:', error);
          },
          complete: () => {
            // Reset the saving flag after the process is complete
            this.isSaving = false;
          }
        });
      } else {
        // alert('Please fill in all required fields.');
        this.notify.info('Please fill in all required fields.');
        console.log('Form is invalid');
        // Optionally reset the form if invalid
        this.customerForm.reset();

        // Reset the saving flag
        this.isSaving = false;
      }
      this.modalService.dismissAll();
      this.customerForm.reset();
    }
    this.getAllcustomers();
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  showQn4: boolean = false;
  showQn5: boolean = false;

  onQn1Change(answer: string) {
    if (answer === 'yes') {
      this.showQn2 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn2Change(answer: string) {
    if (answer === 'yes') {
      this.showQn3 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn3Change(answer: string) {
    this.showQn4 = true;
  }

  onQn4Change(answer: string) {
    if (answer === 'no') {
      this.showQn5 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;
    this.showQn4 = false;
    this.showQn5 = false;
  }

  saveLandingCost() {
    debugger
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }

  getProgressBarColor(progress: number): string {
    if (progress < 50) {
      return 'warn'; // Light Red for less than 50%
    } else if (progress >= 50 && progress < 100) {
      return 'accent'; // Light Yellow for 50% to 99%
    }
    return 'primary'; // Light Blue for 100%
  }
  
  editProjectRow(projectId: number): void {
    debugger
    this.editingRowId = projectId;
  }

  isRowEditing(projectId: number): boolean {
    return this.editingRowId === projectId;
  }

  // onChangeAssignTo(event: any, customer: any): void {   
  //   const engineerId = Number(event.target.value);  
  //   // Find the selected engineer from the engineersData array
  //   const selectedEngineer = this.engineersData.find(user => user.engineer_id === engineerId);  
  //   if (selectedEngineer) {
  //     console.log('Selected Engineer Name:', selectedEngineer.engineer_name);  
  //     // Set the engineer name in the current row
  //     customer.engineer_name = selectedEngineer.engineer_name;
  
  //     // Update the currentstage for the same row
  //     customer.currentstage = customer.currentStage; // Example: Set to 'Procurement'
  //     console.log('Updated Current Stage:', customer.currentstage);
  //   }
  //    this.notify.info('Please select stage');
  // }
  // onChangeAssignTo(event, customer): void {
  //   const engineerId = Number(event.target.value);  
  //   const selectedEngineer = this.engineersData.find(user => user.engineer_id === engineerId);
    
  //   if (selectedEngineer) {
  //     console.log('Selected Engineer Name:', selectedEngineer.engineer_name);
  //     // Set the name to your desired property
  //     // this.customer.engineer_name = selectedEngineer.engineer_name;
  //     this.notify.info('Please select stage');
  //   }
  // }
  onChangeAssignTo(event: any, customer: any): void {
    const engineerId = Number(event.target.value);
  
    // Find the selected engineer
    const selectedEngineer = this.engineersData.find(user => user.engineer_id === engineerId);
  
    if (selectedEngineer) {
      console.log('Selected Engineer Name:', selectedEngineer.engineer_name);
  
      // Update all rows in matchedCustomerData with the same project_id
      this.matchedCustomerData.forEach(row => {
        if (row.project_id === customer.project_id) {
          // Update the engineer name and assigned ID
          row.engineer_name = selectedEngineer.engineer_name;
          row.assigned_to_id = engineerId;
          row.currentstage = customer.currentstage;
          // this.changedstage = customer.currentstage;
  
          // Optionally, set a default currentstage if needed
          if (!row.currentstage || row.currentstage.trim() === '') {
            row.currentstage = ''; // Example placeholder
            this.notify.info('Please select stage');
          }
        }
      });
  
      // Notify the user to select the stage
    }
  }
  

  // onSaveRow(): void {
  //   // Logic to save the row data
  //   this.editingRowId = null; // Reset editing row after saving
  // }
  onSaveRow(rowData: any): void {
    debugger;
  
    // Prevent duplicate API calls
    if (this.isSaving) {
      return;
    }
  
    // Set a flag to indicate the save process is in progress
    this.isSaving = true;
  
    // Check if form is valid (if applicable)
    // if (this.projectForm.valid) {
      // Determine the action: "INSERT" for new or "UPDATE" for existing
      const action = rowData && rowData.project_id ? "UPDATE" : "INSERT";
  
      const updatePayload = {
        action: action,
        project_id: rowData?.project_id || null, // Use project_id if updating, null for insert
        projectName: rowData.projectName,
        rfqDate: rowData.rfqDate,
        // expectedCompletionDate: this.projectForm.get('completionDate')?.value,
        expectedCompletionDate: rowData.expectedCompletionDate,
        // targetLeadTime: Number(this.projectForm.get('targetLT')?.value),
        targetLeadTime: Number(rowData.targetLeadTime),
        created_by_id: this.userId,
        created_date: this.currentDate,
        assigned_to_id: rowData?.assigned_to_id || null,
        assigned_date: this.assignDate,
        // customer_id: Number(this.selectedCustomerId),
        customer_id: Number(rowData.customer_id),
        ageing: rowData?.ageing || 0,
        progress: rowData?.progress || "",
        status: rowData?.status || "Open",
        // currentstage: rowData?.currentstage || "",
        // currentstage: this.changedstage,
        currentstage: this.changedstage || rowData.currentstage,
        activestatus: rowData?.activestatus || ""
      };  
      console.log('updatePayload for API:', updatePayload);
  
      // API call to save or update data
      this.masterService.manage_projects(updatePayload).pipe(
        catchError((error) => {
          console.error('Error saving/updating data:', error);
          // alert('An error occurred while saving/updating the project data. Please try again.');
          this.notify.danger('An error occurred while saving/updating the project data. Please try again.');
          return of(null); // Return a fallback observable
        })
      ).subscribe({
        next: (response) => {
          if (response) {
            console.log(`${action === 'INSERT' ? 'Project added' : 'Project updated'} successfully:`, response);
            // alert(`Project ${action === 'INSERT' ? 'added' : 'updated'} successfully.`);
            // this.notify.success(`Project ${action === 'INSERT' ? 'added' : 'updated'} successfully.`);
            this.notify.success(`Project - ${rowData?.projectName} updated successfully!`);
  
            // Reset form and close modal
            this.projectForm.reset();
            this.closeModal();
  
            // Reload project data
            this.getAllProjectData();
            this.editProjectRow(null);
          }
        },
        error: (error) => {
          // console.error('Unexpected error:', error);
          this.notify.danger(`Something went wrong, ${error}`);
        },
        complete: () => {
          // Reset saving flag
          this.isSaving = false;
        }
      });
    // } else {
    //   alert('Please fill in all required fields.');
    //   console.log('Form is invalid');
    //   this.projectForm.reset();
    //   this.isSaving = false;
    // }
    this.resetFields()
  }

  // onSaveRow(rowData: any): void {
  //   debugger
  //   // Prevent duplicate API calls
  //   if (this.isSaving) {
  //     return;
  //   }
  
  //   // Set a flag to indicate the save process is in progress
  //   this.isSaving = true;
  
  //   // Determine the action: "INSERT" for new or "UPDATE" for existing
  //   const action = rowData && rowData.project_id ? "UPDATE" : "INSERT";
  
  //   // Prepare the payload for the API request
  //   const updatePayload = {
  //     action: action,
  //     project_id: rowData?.project_id || null, // Use project_id if updating, null for insert
  //     projectName: rowData?.projectName,
  //     rfqDate: rowData?.rfqDate,
  //     expectedCompletionDate: rowData?.expectedCompletionDate,
  //     targetLeadTime: Number(rowData?.targetLeadTime),
  //     created_by_id: this.userId,
  //     created_date: this.currentDate,
  //     assigned_to_id: rowData?.assigned_to_id || null,
  //     assigned_date: this.assignDate,
  //     customer_id: Number(rowData?.customer_id),
  //     ageing: rowData?.ageing || 0,
  //     progress: rowData?.progress || "",
  //     status: rowData?.status || "",
  //     currentstage: rowData?.currentstage || "",
  //     activestatus: rowData?.activestatus || "",
  //   };
  
  //   console.log("Payload being sent to API:", updatePayload);
  
  //   // API call to save or update data
  //   this.masterService.manage_projects(updatePayload).subscribe({
  //     next: (response: any) => {
  //       console.log("API Response:", response);
  
  //       if (response?.status === "success") {
  //         alert(`Project ${action === "INSERT" ? "added" : "updated"} successfully.`);
          
  //         // Reset form and close modal
  //         this.projectForm.reset();
  //         this.closeModal();
  
  //         // Reload project data
  //         this.getAllProjectData();
  //       } else {
  //         alert(response?.message || "An error occurred. Please try again.");
  //       }
  //     },
  //     error: (error: any) => {
  //       console.error("Error occurred:", error);
  //       alert("An error occurred while saving/updating the project data. Please try again.");
  //     },
  //     complete: () => {
  //       // Reset saving flag
  //       this.isSaving = false;
  //     },
  //   });
  // }
  

  onChangeStage(eve: any) {
    debugger;
    let changedtage = eve.target.value
    this.changedstage = changedtage
    console.log('val', changedtage);
    debugger   
  }
  
  home() {
    this.router.navigate(['/dashboard-manager'])
  }

}